module.exports = __webpack_public_path__ + "assets/img/page3-first-tab-neutral-faca1824.png";